var module = angular.module('main.resellerorder');

module.component('caResellerOrderRows', {
    templateUrl: 'main/resellerorder/resellerorderview/components/resellerorderrows.cmp.tpl.html',
    bindings: {
        resellerOrder: '<',
        productNumberToExpand: '<'
    },
    controllerAs: 'vm',
    controller: componentController
});

// @ngInject
function componentController($state, $window) {
    var vm = this;

    //Properties
    vm.articleGroupedItemLines = [];

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.getArticleFulfillmentDateRangeString = getArticleFulfillmentDateRangeString;
    vm.getOrderedQuantitySum = getOrderedQuantitySum;
    vm.getFulfilledQuantity = getFulfilledQuantity;
    vm.getLeftToBeFulfilledQuantity = getLeftToBeFulfilledQuantity;
    vm.getTotalFulfillableQuantity = getTotalFulfillableQuantity;
    vm.getTotalAmount = getTotalAmount;
    vm.getOrderFulfilledQuantity = getOrderFulfilledQuantity;
    vm.getOrderLeftToBeFulfilledQuantity = getOrderLeftToBeFulfilledQuantity;
    vm.getOrderTotalFulfillableQuantity = getOrderTotalFulfillableQuantity;
    vm.getOrderTotalAmount = getOrderTotalAmount;
    vm.toggleExpandAll = toggleExpandAll;
    vm.goToProduct = goToProduct;

    function onInit() {

    }

    function onChanges(changes) {
        vm.articleGroupedItemLines = [];
        groupRowsByArticle();

        if (vm.productNumberToExpand && vm.productNumberToExpand !== '') {
            expandProduct(vm.productNumberToExpand);
        }
    }

    function goToProduct(articleId) {
        var url = $state.href('product.articles.article', {articleId: articleId});
        $window.open(url,'_blank');
    }

    function toggleExpandAll() {
        var allAreExpanded = true;
        _.forEach(vm.articleGroupedItemLines, function (o) {
            if (!o.showRows || o.showRows === false) {
                allAreExpanded = false;
            }
        });

        _.forEach(vm.articleGroupedItemLines, function(art) {
            if (!allAreExpanded) {
                art.showRows = true;
            } else {
                art.showRows = false;
            }
        });
    }

    function expandProduct(productNumber) {
        _.forEach(vm.articleGroupedItemLines, function (art) {
            if (productNumber && productNumber !== '' && art.AlternativeArticleNumber === productNumber) {
                art.showRows = true;
            }
        });
    }

    function groupRowsByArticle() {
        var lineItemGroups = _.groupBy(vm.resellerOrder.lineItems, function(item) { return item.articleId; });
        _.forEach(lineItemGroups, function (group) {
            var groupRow = {
                AlternativeArticleNumber: group[0].alternativeArticleNumber,
                ArticleName: group[0].articleName,
                DisplayArticleNumber: group[0].displayArticleNumber,
                FulfillmentDateRange: getArticleFulfillmentDateRangeString(group),
                FulfilledQuantity: getFulfilledQuantity(group),
                LeftToBeFulfilledQuantity: getLeftToBeFulfilledQuantity(group),
                TotalFulfillableQuantity: getTotalFulfillableQuantity(group),
                AveragePricePerPiece: getAveragePricePerPiece(group),
                AveragePriceMinusDiscountPerPiece: getAveragePriceMinusDiscountPerPiece(group),
                TotalAmount: getTotalAmount(group),
                LineItems: _.orderBy(group, function(lineItem) { return [lineItem.variantDetailName, lineItem.variantDetail2SortOrder]; })
            };

            vm.articleGroupedItemLines.push(groupRow);
        });
    }

    function getArticleFulfillmentDateRangeString(lineItems) {
        var datesString = "";
        var dates = [];
        _.forEach(lineItems, function(lineItem) {
            dates = dates.concat(lineItem.fullfillmentDates);
            _.forEach(lineItem.fulfillmentDates, function(dateString) {
                dates.add(Date.parse(dateString));
            });
        });

        var minDate = _.min(dates);
        var maxDate = _.max(dates);
        if (minDate !== undefined && maxDate !== undefined) {
            if (minDate !== maxDate) {
                datesString = minDate.toString().substring(0,16) + " - " + maxDate.toString().substring(0,16);
                datesString = datesString.replace(/T/g, ' ');
            } else if (minDate === maxDate) {
                datesString = minDate.toString().substring(0,16);
                datesString = datesString.replace(/T/g, ' ');
            }
        }
        return datesString;
    }

    function getOrderedQuantitySum(lineItems) {
        var quantity = _.sumBy(lineItems, function(lineItem) {
            return lineItem.quantity;
        });
        return quantity;
    }

    function getFulfilledQuantity(lineItems) {
        return _.sumBy(lineItems, function(lineItem) {
            return lineItem.fulfilledQuantity;
        });
    }

    function getLeftToBeFulfilledQuantity(lineItems) {
        var sum = _.sumBy(lineItems, function(lineItem) {
            return lineItem.quantity - lineItem.fulfilledQuantity;
        });
        sum = Math.max(sum, 0);
        return sum;
    }

    function getTotalFulfillableQuantity(lineItems) {
        return _.sumBy(lineItems, function(lineItem) {
            return lineItem.quantity;
        });
    }

    function getAveragePricePerPiece(lineItems) {
        var count = 0;
        var totalAmount = 0;
        var average = 0;
        _.forEach(lineItems, function(lineItem) {
            totalAmount += lineItem.amount;
            count += 1;
        });
        average = totalAmount / count;
        return average;
    }
    function getAveragePriceMinusDiscountPerPiece(lineItems) {
        var count = 0;
        var totalAmount = 0;
        var average = 0;
        _.forEach(lineItems, function(lineItem) {
            totalAmount += lineItem.amount - lineItem.discountAmountPerItem;
            count += 1;
        });
        average = totalAmount / count;
        return average;
    }

    function getTotalAmount(lineItems) {
        return _.sumBy(lineItems, function(lineItem) {
            return (lineItem.amount - lineItem.discountAmountPerItem) * lineItem.quantity;
        });
    }

    function getOrderFulfilledQuantity() {
        var lineItems = vm.resellerOrder.lineItems;
        return getFulfilledQuantity(lineItems);
    }

    function getOrderLeftToBeFulfilledQuantity() {
        var lineItems = vm.resellerOrder.lineItems;
        return getLeftToBeFulfilledQuantity(lineItems);
    }

    function getOrderTotalFulfillableQuantity() {
        var lineItems = vm.resellerOrder.lineItems;
        return getTotalFulfillableQuantity(lineItems);
    }

    function getOrderTotalAmount() {
        var lineItems = vm.resellerOrder.lineItems;
        return getTotalAmount(lineItems);
    }

}
